<template>
  <div class="img-preview-wrapper">
    <div v-if="loading" class="d-flex justify-content-center align-items-center h-100">
      <div class="spinner-border spinner-border-sm text-primary" role="status">
        <span class="visually-hidden">{{ $t('common.loading') }}</span>
      </div>
    </div>
    <div v-else-if="error" class="error-container h-100 d-flex align-items-center justify-content-center">
      <i class="ti ti-alert-triangle text-danger"></i>
    </div>
    <img v-else-if="imageUrl" :src="imageUrl" :alt="alt" :style="{ width, height }" class="img-fluid" />
    <div v-else class="placeholder-container h-100 d-flex align-items-center justify-content-center">
      <i class="ti ti-photo text-muted"></i>
    </div>
  </div>
</template>

<script>
import { ref, onMounted, watch } from 'vue';
import fileManagementService from '@/services/fileManagementService';

export default {
  name: 'ImgPreview',
  props: {
    fileId: {
      type: String,
      required: true
    },
    alt: {
      type: String,
      default: 'Material image'
    },
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '100%'
    }
  },
  setup(props) {
    const loading = ref(false);
    const error = ref(false);
    const imageUrl = ref(null);

    const loadImage = async () => {
      if (!props.fileId) return;
      
      loading.value = true;
      error.value = false;
      
      try {
        const response = await fileManagementService.getFilePreviewUrl(props.fileId);
        // Check if response has blobUrl property
        if (response && response.blobUrl) {
          imageUrl.value = response.blobUrl;
        } else {
          console.error('Invalid response format from getFilePreviewUrl');
          error.value = true;
        }
      } catch (err) {
        console.error('Error loading image:', err);
        error.value = true;
      } finally {
        loading.value = false;
      }
    };
    
    // Watch for changes to fileId and reload image when it changes
    watch(() => props.fileId, () => {
      if (props.fileId) {
        loadImage();
      } else {
        imageUrl.value = null;
      }
    });
    
    // Load image on mount
    onMounted(() => {
      if (props.fileId) {
        loadImage();
      }
    });
    
    return {
      loading,
      error,
      imageUrl
    };
  }
};
</script>

<style scoped>
.img-preview-wrapper {
  display: block;
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
}

.error-container, .placeholder-container {
  border: 1px dashed #ccc;
  color: #6c757d;
}
</style> 